import { apiClient } from '../../../utils/axios';
import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { AxiosError } from 'axios';

const disconnectShopifyHandler = async ({ payload }) => {
  const passingData = { data: { ...payload } };
  const { data } = await apiClient.delete(`/shopify-oauth/disconnect`, passingData);
  return data;
};

export const useDisconnectShopifyHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: disconnectShopifyHandler,
    onSuccess: (data, variables, context) => {
      dispatch(showSnackbar({ message: 'Shopify account disconnected successfully', severity: 'success' }));
      queryClient.invalidateQueries({ queryKey: ['shopify-stores'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data, severity: 'error' }));
      }
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const onDisconnect = async (data) => {
    const payload = { ...data };
    mutation.mutate({ payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onDisconnect: onDisconnect,
  };
};
